/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { Bot, Menu, Plus } from 'lucide-react';

import { Button } from '../ui/button';
import { CardHeader, CardTitle } from '../ui/card';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

interface ChatHeaderProps {
    onToggleHistory: () => void;
    onNewChat: () => void;
    isHistoryActive?: boolean;
    isLoading?: boolean;
    disabled?: boolean;
}

export const ChatHeader = ({
    onToggleHistory,
    onNewChat,
    isHistoryActive = false,
    isLoading = false,
    disabled = false,
}: ChatHeaderProps) => {
    return (
        <CardHeader className="pb-3 flex-shrink-0 relative z-10">
            <CardTitle className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Bot className="h-5 w-5 text-purple-700" />
                    Code Agent Chat
                </div>
                <div className="flex items-center gap-2">
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={onNewChat}
                                    disabled={isLoading || disabled}
                                    className="h-8 w-8"
                                >
                                    <Plus className="h-4 w-4" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>New Chat</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant={isHistoryActive ? 'default' : 'ghost'}
                                    size="icon"
                                    onClick={onToggleHistory}
                                    disabled={isLoading || disabled}
                                    className={`h-8 w-8 ${
                                        isHistoryActive ? 'bg-purple-700 text-white hover:bg-purple-700/90' : ''
                                    }`}
                                >
                                    <Menu className="h-4 w-4" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Chat History</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </CardTitle>
        </CardHeader>
    );
};
